export default {
  meta: {
    title: '查询历史',
    url: '/surround', // 埋点用，记录所属模块
    parentPath: ['/surround'],
    breadcrumbs: {
      path: ['/surround'], // 该模块首页
      name: ['周边查询'],
    },
  },
};
